import { action } from 'satcheljs/lib/legacy';
export default action('clearAttachmentFilesToUpload')(function clearAttachmentFilesToUpload(viewState) {
    viewState.attachmentFilesToUpload = null;
});
//# sourceMappingURL=clearAttachmentFilesToUpload.js.map